import type { SVGProps } from 'react'

export type IconProps = SVGProps<SVGSVGElement> & { size?: number }

function Icon({ size = 16, children, viewBox, ...props }: IconProps) {
  return (
    <svg
      viewBox={viewBox ?? '0 0 24 24'}
      width={size}
      height={size}
      fill="none"
      stroke="currentColor"
      strokeWidth={1.9}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...props}
    >
      {children}
    </svg>
  )
}

export const HomeIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3 11l9-7 9 7v9a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1z" />
  </Icon>
)
export const UsersIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8" />
  </Icon>
)
export const CarIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M3 13l1.6-4.6A2 2 0 0 1 6.5 7h11a2 2 0 0 1 1.9 1.4L21 13" />
    <rect x="2" y="13" width="20" height="6" rx="1.5" />
    <circle cx="7" cy="19" r="1.5" />
    <circle cx="17" cy="19" r="1.5" />
  </Icon>
)
export const AlertIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M10.3 3.9 1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </Icon>
)
export const ClockIcon = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3.5 2" />
  </Icon>
)
export const FlameIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M8.5 14.5A2.5 2.5 0 0 0 11 17a2.5 2.5 0 0 0 2.5-2.5c0-1.4-.5-2-1-3-1.1-2.1-.2-4 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7.5 7.5 0 1 1-15 0c0-1.2.4-2.3 1-3" />
  </Icon>
)
export const ShieldIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M12 21s7.5-3.6 7.5-9.5V5.5L12 3 4.5 5.5v6c0 5.9 7.5 9.5 7.5 9.5z" />
  </Icon>
)
export const ArrowUpRightIcon = (p: IconProps) => (
  <Icon strokeWidth={2.2} {...p}>
    <path d="M7 17L17 7M8 7h9v9" />
  </Icon>
)
export const ChevronDownIcon = (p: IconProps) => (
  <Icon strokeWidth={2.2} {...p}>
    <path d="M6 9l6 6 6-6" />
  </Icon>
)
export const PlayIcon = (p: IconProps) => (
  <Icon fill="currentColor" stroke="none" {...p}>
    <path d="M8 5v14l11-7z" />
  </Icon>
)
export const SunIcon = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </Icon>
)
export const MoonIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
  </Icon>
)
export const LogoutIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
  </Icon>
)
export const LogoIcon = (p: IconProps) => (
  <Icon size={44} viewBox="0 0 44 44" strokeWidth="none" {...p}>
    <path
      d="M19.3848 40.9087C29.5015 40.9087 37.7027 32.7075 37.7027 22.5908C37.7027 12.4741 29.5015 4.27289 19.3848 4.27289C9.2681 4.27289 1.06689 12.4741 1.06689 22.5908C1.06689 32.7075 9.2681 40.9087 19.3848 40.9087Z"
      fill="#FFD25A"
    />
    <path
      d="M18.4958 4.41581C18.4958 3.74755 17.9541 3.20581 17.2858 3.20581C7.7391 3.20581 -8.346e-07 10.9449 0 20.4916C5.84001e-08 21.1599 0.541739 21.7016 1.21 21.7016C10.7567 21.7016 18.4958 13.9625 18.4958 4.41581Z"
      fill="black"
    />
    <path
      d="M38.7702 20.4915C38.7702 21.1598 38.2285 21.7015 37.5602 21.7015C28.0135 21.7015 20.2744 13.9624 20.2744 4.41575C20.2744 3.74749 20.8162 3.20575 21.4844 3.20575C31.0311 3.20575 38.7702 10.9449 38.7702 20.4915Z"
      fill="black"
    />
    <path
      d="M18.4958 40.7658C18.4958 41.4341 17.9541 41.9758 17.2858 41.9758C7.7391 41.9758 0 34.2367 0 24.6901C0 24.0218 0.541738 23.4801 1.21 23.4801C10.7567 23.4801 18.4958 31.2192 18.4958 40.7658Z"
      fill="black"
    />
    <path
      d="M38.7702 24.6901C38.7702 24.0218 38.2285 23.4801 37.5602 23.4801C28.0135 23.4801 20.2744 31.2192 20.2744 40.7659C20.2744 41.4341 20.8162 41.9759 21.4844 41.9759C31.0311 41.9759 38.7702 34.2368 38.7702 24.6901Z"
      fill="black"
    />
    <path
      d="M19.385 27.7483C22.2334 27.7483 24.5425 25.4392 24.5425 22.5908C24.5425 19.7424 22.2334 17.4333 19.385 17.4333C16.5366 17.4333 14.2275 19.7424 14.2275 22.5908C14.2275 25.4392 16.5366 27.7483 19.385 27.7483Z"
      fill="white"
    />
    <path
      d="M37.7357 4.84464C38.9322 5.71398 40.6069 5.44873 41.4763 4.25219C42.3456 3.05564 42.0804 1.38092 40.8838 0.511578C39.6873 -0.35776 38.0125 -0.0925109 37.1432 1.10403C36.2739 2.30057 36.5391 3.9753 37.7357 4.84464Z"
      fill="#FE3737"
    />
  </Icon>
)
export const ArrowLeftIcon = (p: IconProps) => (
  <Icon strokeWidth={2.2} {...p}>
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </Icon>
)
export const CloseIcon = (p: IconProps) => (
  <Icon strokeWidth={2.2} {...p}>
    <path d="M18 6L6 18M6 6l12 12" />
  </Icon>
)
export const ExpandIcon = (p: IconProps) => (
  <Icon {...p}>
    <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
  </Icon>
)
export const SearchIcon = (p: IconProps) => (
  <Icon {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="M20 20l-3.5-3.5" />
  </Icon>
)
